<template>
  <modal
    :name="name"
    :scrollable="true"
    height="auto"
  >
    <div>
      <header class="w-full py-5 border-b border-sc-gray-light">
        <div class="flex justify-between px-5 text-xl text-left text-sc-gray-dark">
          <p>
            {{ $t('message.table.confirmationModal.confirmation') }}
          </p>
          <button @click="hide()">
            <img
              :src="require('@assets/images/cross.svg')"
              class="self-center h-5 p-1 ml-1"
              alt="cerrar"
            >
          </button>
        </div>
      </header>
      <div
        class="flex flex-col p-5 text-center border-sc-gray-light"
        :class="{ 'border-b': !isLastStep }"
      >
        <p :class="[isLastStep ? 'text-xl text-sc-gray' : 'text-sm text-sc-gray mb-5 mt-3']">
          {{ content }}
        </p>
        <b-input
          type="textarea"
          :placeholder="this.stepKey === 'single' ? singlePlaceholder : manyPlaceholder"
          class="bottom-0 m-1"
          v-model="newComment"
          v-if="!isLastStep"
        />
      </div>
      <div class="flex w-full p-5">
        <button
          class="inline-block w-full py-3 mr-2 text-sm leading-5 text-center text-white rounded focus:outline-none hover:opacity-75 shadow-sc-button bg-sc-blue hover:bg-sc-blue-light"
          @click="onConfirmButton()"
        >
          {{ confirmButtonText }}
        </button>
        <button
          class="inline-block w-full py-3 ml-2 text-sm leading-5 text-center rounded text-primary focus:outline-none hover:opacity-75 shadow-sc-button"
          @click="onCancelButton()"
        >
          {{ $t('message.table.confirmationModal.cancel') }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      stepKey: this.step,
      active: this.isModalActive,
      newComment: '',
      singlePlaceholder: this.$i18n.t('message.table.commentPlaceholder.single'),
      manyPlaceholder: this.$i18n.t('message.table.commentPlaceholder.many'),
      steps: {
        'single': {
          content: this.$i18n.t('message.table.warning.changeStatus'),
        },
        'selected': {
          content: this.$i18n.t('message.table.warning.changeStatusSelected'),
        },
        'all': {
          content: this.$i18n.t('message.table.warning.changeStatusAll'),
        },
        'allLastStep': {
          content: this.$i18n.t('message.table.warning.changeStatusAllLastStep'),
          confirm: 'Aprobar Todos los Movimientos',
        },
      },
    };
  },
  props: {
    isModalActive: {
      type: Boolean,
      default: false,
    },
    step: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: 'confirmation-modal',
    },
  },
  computed: {
    confirmButtonText() {
      return this.currentStep.confirme || 'Confirmar';
    },
    isLastStep() {
      return this.stepKey === 'allLastStep';
    },
    currentStep() {
      return this.steps[this.stepKey];
    },
    content() {
      return this.currentStep.content;
    },
  },
  watch: {
    step() {
      this.stepKey = this.step;
    },
  },
  methods: {
    lastStep() {
      const nextStep = this.steps.allLastStep;
      if (!nextStep) return;
      this.stepKey = this.step;
    },
    nextStep() {
      const nextStep = this.steps.allLastStep;
      if (!nextStep) return;
      this.stepKey = 'allLastStep';
    },
    onCancelButton() {
      if (this.isLastStep) {
        this.lastStep();
      } else {
        this.hide();
      }
    },
    onConfirmButton() {
      if (this.stepKey === 'all') {
        this.nextStep();
      } else {
        this.confirmation();
      }
    },
    confirmation() {
      this.$emit('confirmation', this.newComment);
      this.newComment = '';
      this.hide();
    },
    show() {
      this.stepKey = this.step;
      this.$modal.show(this.name);
    },
    hide() {
      this.$modal.hide(this.name);
    },
  },
};
</script>
